import { render, staticRenderFns } from "./IdActiveView.vue?vue&type=template&id=7f2141aa&scoped=true&"
import script from "./IdActiveView.vue?vue&type=script&lang=js&"
export * from "./IdActiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2141aa",
  null
  
)

export default component.exports